import type { ReactNode } from "react";

interface Props {
	condition: boolean
	wrap: (children: ReactNode) => ReactNode
	children: ReactNode
}

const ConditionalWrap = ({ condition , wrap, children }: Props): JSX.Element => (condition ? wrap(children) : children) as JSX.Element

export default ConditionalWrap
